<template>
    <div>
        <h2 class="mb-1">Peer Services Intake Report</h2>
        
        <div style="display: flex; flex-wrap: wrap; align-items: center;" class="mb-2">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-50"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="prevRange()"
            >
                <feather-icon icon="ChevronLeftIcon" />
            </b-button>

            <b-form-group
                label="Start Date"
                class="mr-50 w-10"
            >
                <date-picker v-model="startDate" type="month" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-if="selectedRangeDate === 'month' || selectedRangeDate === 'quarter'"></date-picker>
                <date-picker v-model="startDate" type="year" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="selectedRangeDate === 'year'"></date-picker>
                <date-picker v-model="startDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="!selectedRangeDate || selectedRangeDate === 'custom'"></date-picker>
            </b-form-group>
        
            <b-form-group
                label="End Date"
                class="mr-50"
            >
                <date-picker v-model="endDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" :disabled="selectedRangeDate === 'month' || selectedRangeDate === 'quarter' || selectedRangeDate === 'year' ? true : false"></date-picker>
            </b-form-group>

            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon ml-0"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="nextRange()"
            >
                <feather-icon icon="ChevronRightIcon" />
            </b-button>
            
            <div :class="!selectedRangeDate ? 'pl-1' : 'pl-1'">
                <b-form-group>
                    <b-form-radio-group
                        v-model="selectedRangeDate"
                        button-variant="outline-primary range-date"
                        buttons
                        class="p-0 mr-2"
                    >
                        <b-form-radio style="height: 37px; padding: 11px;" v-for="(option,index) in optionsRangeDate" :key="index + makeid(6)" :value="option.value">{{option.text}}</b-form-radio>
                        <b-form-radio style="height: 37px; padding: 10px;" v-if="selectedRangeDate" value="x">x</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            
            <b-form-group label="New or Returning Client">
                <v-select
                    v-model="filterClientType"
                    placeholder="New or Returning Client"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="clientTypeOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Client Status">
                <v-select
                    v-model="filterClientStatus"
                    placeholder="Client Status"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="clientStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Referral Source">
                <v-select
                    v-model="filterReferralSource"
                    placeholder="Referral Source"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="referralSourceOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Service Status">
                <v-select
                    v-model="filterServiceStatus"
                    placeholder="Service Status"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="serviceStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Presenting Problems">
                <v-select
                    v-model="filterPresentingProblems"
                    placeholder="Presenting Problems"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="presentingProblemsOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Legal Involvement">
                <v-select
                    v-model="filterLegalInvolvement"
                    placeholder="Legal Involvement"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="yesNoOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Client Release Signed">
                <v-select
                    v-model="filterReleaseSigned"
                    placeholder="Client Release Signed"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="yesNoOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Race">
                <v-select
                    v-model="filterRace"
                    placeholder="Race"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="raceOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Hispanic Origin">
                <v-select
                    v-model="filterEthnicity"
                    placeholder="Hispanic Origin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="hispanicOriginOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Asian Origin">
                <v-select
                    v-model="filterAsianOrigin"
                    placeholder="Asian Origin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="asianOriginOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Pacific Islander Origin">
                <v-select
                    v-model="filterPacificIslanderOrigin"
                    placeholder="Pacific Islander Origin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pacificIslanderOriginOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Household Income">
                <v-select
                    v-model="filterHouseholdIncome"
                    placeholder="Household Income"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="householdIncomeOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Types of Gambling">
                <v-select
                    v-model="filterGamblingTypes"
                    placeholder="Types of Gambling"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="gamblingTypesOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Employment Status">
                <v-select
                    v-model="filterEmploymentStatus"
                    placeholder="Employment Status"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="employmentStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Education Level">
                <v-select
                    v-model="filterEducationLevel"
                    placeholder="Education Level"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="highestGradeOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Veteran">
                <v-select
                    v-model="filterVeteran"
                    placeholder="Veteran"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="yesNoOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Industry of Employment">
                <v-select
                    v-model="filterIndustry"
                    placeholder="Industry of Employment"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="industryOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Marital Status">
                <v-select
                    v-model="filterMaritalStatus"
                    placeholder="Marital Status"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="maritalStatusOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Religious Preference">
                <v-select
                    v-model="filterReligiousPreference"
                    placeholder="Religious Preference"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="religiousPreferenceOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Age">
                <v-select
                    v-model="filterAge"
                    placeholder="Age"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="ageOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Sexual Orientation">
                <v-select
                    v-model="filterSexualOrientation"
                    placeholder="Sexual Orientation"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="sexualOrientationOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Gender Identity">
                <v-select
                    v-model="filterGenderIdentity"
                    placeholder="Gender Identity"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="genderIdentityOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Transgender">
                <v-select
                    v-model="filterTransgender"
                    placeholder="Transgender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="transgenderOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Frequency of Gambling">
                <v-select
                    v-model="filterGamblingFrequency"
                    placeholder="Frequency of Gambling"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="gamblingFrequencyOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Gambling Locations">
                <v-select
                    v-model="filterGamblingLocations"
                    placeholder="Gambling Locations"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="gamblingLocationsOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <div>
                <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-primary"
                    class="mb-1 mt-2 p-75"
                    @click="resetFilters"
                >
                    <feather-icon
                        icon="XIcon"
                        class="mr-50"
                    />
                    <span class="align-middle">Reset filters</span>
                </b-button>
            </div>
        </div>

        <b-card>
            <h5>Peer Services Intake Forms</h5>
            <hr>
            <b-row>
                <!-- Total Forms -->
                <b-col lg="3" md="3" sm="12">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ totalIntakeForms }}
                                </h2>
                                <span>Total Intake Forms</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Client Type -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in clientTypeOptions" :key="'client-type-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'New or Returning Client') }}
                                </h2>
                                <span>New or Returning Client / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Client Status -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in clientStatusOptions" :key="'client-status-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Client Status') }}
                                </h2>
                                <span>Client Status / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Referral Source -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in referralSourceOptions" :key="'referral-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Referral Source') }}
                                </h2>
                                <span>Referral Source / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Service Status -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in serviceStatusOptions" :key="'service-status-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Service Status') }}
                                </h2>
                                <span>Service Status / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Presenting Problems -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in presentingProblemsOptions" :key="'presenting-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Presenting Problems') }}
                                </h2>
                                <span>Presenting Problems / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Legal Involvement -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in yesNoOptions" :key="'legal-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Legal Involvement') }}
                                </h2>
                                <span>Legal Involvement / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Release Signed -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in yesNoOptions" :key="'release-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Client Release Signed') }}
                                </h2>
                                <span>Client Release Signed / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Race -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in raceOptions" :key="'race-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Race') }}
                                </h2>
                                <span>Race / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Hispanic Origin -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in hispanicOriginOptions" :key="'hispanic-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Hispanic Origin') }}
                                </h2>
                                <span>Hispanic Origin / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Asian Origin -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in asianOriginOptions" :key="'asian-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Asian Origin') }}
                                </h2>
                                <span>Asian Origin / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Pacific Islander Origin -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in pacificIslanderOriginOptions" :key="'pacific-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Pacific Islander Origin') }}
                                </h2>
                                <span>Pacific Islander Origin / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Household Income -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in householdIncomeOptions" :key="'income-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Household Income') }}
                                </h2>
                                <span>Household Income / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Types of Gambling -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in gamblingTypesOptions" :key="'gambling-types-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Types of Gambling') }}
                                </h2>
                                <span>Types of Gambling / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Employment Status -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in employmentStatusOptions" :key="'employment-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Employment Status') }}
                                </h2>
                                <span>Employment Status / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Education Level -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in highestGradeOptions" :key="'education-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Education Level') }}
                                </h2>
                                <span>Education Level / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Veteran -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in yesNoOptions" :key="'veteran-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Veteran') }}
                                </h2>
                                <span>Veteran / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Industry -->
            <b-col lg="3" md="3" sm="12" v-for="(item, index) in industryOptions" :key="'industry-' + index">
                <b-card no-body style="border: 1px solid #ecebed;">
                    <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                                {{ getCounter(item, 'Industry') }}
                            </h2>
                            <span>Industry / {{ item }}</span>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <!-- Marital Status -->
            <b-col lg="3" md="3" sm="12" v-for="(item, index) in maritalStatusOptions" :key="'marital-' + index">
                <b-card no-body style="border: 1px solid #ecebed;">
                    <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                                {{ getCounter(item, 'Marital Status') }}
                            </h2>
                            <span>Marital Status / {{ item }}</span>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <!-- Religious Preference -->
            <b-col lg="3" md="3" sm="12" v-for="(item, index) in religiousPreferenceOptions" :key="'religious-' + index">
                <b-card no-body style="border: 1px solid #ecebed;">
                    <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                                {{ getCounter(item, 'Religious Preference') }}
                            </h2>
                            <span>Religious Preference / {{ item }}</span>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <!-- Age -->
            <b-col lg="3" md="3" sm="12" v-for="(item, index) in ageOptions" :key="'age-' + index">
                <b-card no-body style="border: 1px solid #ecebed;">
                    <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                                {{ getCounter(item, 'Age') }}
                            </h2>
                            <span>Age / {{ item }}</span>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <!-- Sexual Orientation -->
            <b-col lg="3" md="3" sm="12" v-for="(item, index) in sexualOrientationOptions" :key="'sexual-' + index">
                <b-card no-body style="border: 1px solid #ecebed;">
                    <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                                {{ getCounter(item, 'Sexual Orientation') }}
                            </h2>
                            <span>Sexual Orientation / {{ item }}</span>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <!-- Gender Identity -->
            <b-col lg="3" md="3" sm="12" v-for="(item, index) in genderIdentityOptions" :key="'gender-' + index">
                <b-card no-body style="border: 1px solid #ecebed;">
                    <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                                {{ getCounter(item, 'Gender Identity') }}
                            </h2>
                            <span>Gender Identity / {{ item }}</span>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <!-- Transgender -->
            <b-col lg="3" md="3" sm="12" v-for="(item, index) in transgenderOptions" :key="'transgender-' + index">
                <b-card no-body style="border: 1px solid #ecebed;">
                    <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                                {{ getCounter(item, 'Transgender') }}
                            </h2>
                            <span>Transgender / {{ item }}</span>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <!-- Gambling Frequency -->
            <b-col lg="3" md="3" sm="12" v-for="(item, index) in gamblingFrequencyOptions" :key="'frequency-' + index">
                <b-card no-body style="border: 1px solid #ecebed;">
                    <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                                {{ getCounter(item, 'Gambling Frequency') }}
                            </h2>
                            <span>Gambling Frequency / {{ item }}</span>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <!-- Gambling Locations -->
            <b-col lg="3" md="3" sm="12" v-for="(item, index) in gamblingLocationsOptions" :key="'locations-' + index">
                <b-card no-body style="border: 1px solid #ecebed;">
                    <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                                {{ getCounter(item, 'Gambling Locations') }}
                            </h2>
                            <span>Gambling Locations / {{ item }}</span>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </b-card>

    <download-csv 
        :data="jsonData"
        class="mb-1 btn btn-default"
        name="peer-services-intake-report.csv"
        :style="readyToExport ? 'background: #94221e; color: #fff; cursor: pointer; opacity: 1;' : 'background: #94221e; color: #fff; cursor: no-drop; opacity: 0.5;'"
        delimiter=","
        v-if="isDataSpecialist"
    >
        CSV Export
        <b-spinner small v-if="!readyToExport" />
    </download-csv>
</div>
</template>
<script>
import { 
    BButton, BRow, BCol, BFormGroup, BCard, BCardBody, BSpinner, BFormRadioGroup, BFormRadio
} from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import { db, auth } from '@/firebase'

export default {
    data() {
        return {
            // Date filters
            startDate: null,
            endDate: null,
            selectedRangeDate: 'month',
            optionsRangeDate: [
                { text: 'Month', value: 'month' },
                { text: 'Quarter', value: 'quarter' },
                { text: 'Year', value: 'year' },
                { text: 'Custom', value: 'custom' },
            ],
            rangeDinamic: false,
            
            // Filters
            filterClientType: '',
            filterClientStatus: '',
            filterReferralSource: '',
            filterServiceStatus: '',
            filterPresentingProblems: '',
            filterLegalInvolvement: '',
            filterReleaseSigned: '',
            filterRace: '',
            filterEthnicity: '',
            filterAsianOrigin: '',
            filterPacificIslanderOrigin: '',
            filterHouseholdIncome: '',
            filterGamblingTypes: '',
            filterEmploymentStatus: '',
            filterEducationLevel: '',
            filterVeteran: '',
            filterIndustry: '',
            filterMaritalStatus: '',
            filterReligiousPreference: '',
            filterAge: '',
            filterSexualOrientation: '',
            filterGenderIdentity: '',
            filterTransgender: '',
            filterGamblingFrequency: '',
            filterGamblingLocations: '',

            // Data
            totalIntakeForms: 0,
            arrayResults: [],
            filteredData: [],
            jsonData: [],
            
            // Loading states
            isBusy: true,
            isDataSpecialist: false,
            readyToExport: false,

            // Options
            clientTypeOptions: ['New client', 'Returning client', 'N/A'],
            clientStatusOptions: ['Problem Gambler', 'Family Member/Significant Other'],
            yesNoOptions: ['Yes', 'No'],
            referralSourceOptions: [
            'Hopeline',
            'Family member/Self',
            'Friends or Other Individual',
            'Problem Gambling Self-Help Group Meetings',
            'Substance Use Self-Help Group Meetings',
            'Financial Counseling',
            'Crisis Services',
            'Problem Gambling Treatment Services',
            'Substance Use Treatment Services',
            'Recovery Support Services'
            ],
            familyReferralTypeOptions: ['Self-Referral', 'Spouse', 'Family member'],
            selfHelpGroupOptions: ['GA', 'GamAnon', 'Smart Recovery', 'Other'],
            treatmentTypeOptions: ['Inpatient Rehabilitation', 'Residential', 'Outpatient'],
            recoveryServiceOptions: [
            'Recovery Community and Outreach Center',
            'Youth Clubhouse',
            'Peer Advocate',
            'Open Access Center',
            'Family Navigator',
            'Regional Addiction Resource Center',
            'Other'
            ],
            presentingProblemsOptions: [
            'Co-occurring mental health disorders',
            'Co-occurring substance use disorders',
            'Employment difficulties',
            'Financial difficulties',
            'Physical health problems',
            'Relationship difficulties',
            'Education difficulties',
            'Marital difficulties',
            'Bankruptcy',
            'Borrowing or theft from family/friends',
            'Losing savings/retirement',
            'Significant debt',
            'Embezzlement',
            'Suicidal Ideation/Thoughts/Attempts',
            'Legal Issues',
            'Arrest',
            'Incarceration',
            'N/A'
            ],
            legalSystemTypeOptions: [
            'Pre-Court Sentence (no Alternative to Incarceration)',
            'Pre-Court Sentence (Alternative to Incarceration)',
            'Probation (no Alternative to Incarceration)',
            'Probation (Alternative to Incarceration)',
            'Correctional-based setting',
            'Post-correctional supervision',
            'Other Alternative to Incarceration'
            ],
            raceOptions: [
            'Alaskan Native',
            'Asian',
            'Black or African American',
            'Hawaiian or other Pacific Islander',
            'Middle Eastern or North African',
            'Native American, Indigenous, or American Indian',
            'White',
            'Some other race, ethnicity, origin',
            'Prefer not to answer'
            ],
            hispanicOriginOptions: [
            'Cuban',
            'Mexican',
            'Puerto Rican',
            'Hispanic/Latino/a/x, Not Specified',
            'Not of Hispanic Origin',
            'Prefer not to answer'
            ],
            asianOriginOptions: [
            'Asian Indian',
            'Bangladeshi',
            'Burmese',
            'Cambodian',
            'Chinese',
            'Filipino',
            'Hmong',
            'Indonesian',
            'Japanese',
            'Korean',
            'Laotian',
            'Malaysian',
            'Nepalese',
            'Pakistani',
            'Sri Lankan',
            'Taiwanese',
            'Thai',
            'Tibetan',
            'Vietnamese',
            'Asian, Not Specified',
            'Not of Asian Origin',
            'Prefer not to answer'
            ],
            pacificIslanderOriginOptions: [
            'Fijian',
            'Guamanian',
            'Hawaiian',
            'Samoan',
            'Tongan',
            'Pacific Islander, Not Specified',
            'Not of Pacific Islander Origin',
            'Prefer not to answer'
            ],
            householdIncomeOptions: [
            'Less than 15k',
            '15k - 30k',
            '30,001 - 50k',
            '50,001k - 75k',
            '75,001 - 100k',
            'More than 100k',
            'N/A'
            ],
            gamblingTypesOptions: [
            'None',
            'Bingo',
            'Cards',
            'Horses',
            'Dogs/other animals',
            'Office pools',
            'Roulette',
            'Slot machines',
            'Sports',
            'Stock/commodities market',
            'Video lottery terminal',
            'Dice games/Coin flips',
            'Lottery (Numbers, Scratch-offs, Quick Draw)',
            'Game of Skill for Money (video games, bowling, pool, etc.)',
            'Raffles (including 50/50) or pull tabs',
            'Native American (Turning Stone, Seneca, Akwesasne, etc.)',
            'Gambling on the Internet (eGaming)',
            'Commercial Casinos (Tioga, Del Lago Resorts, World-Catskills, Rivers, etc.)',
            'Sports Betting at a Casino',
            'Mobile Sports Betting (MSB)',
            'Prefer not to answer'
            ],
            employmentStatusOptions: [
            'Employed Full Time - 35 hours or more/week',
            'Employed Part Time - less than 35 hours/week',
            'Unemployed, looking for work',
            'Unemployed, not looking for work',
            'Not in Labor Force, Retired',
            'Not in Labor Force, Disabled',
            'Not in Labor Force, Student',
            'Not in Labor Force, Other',
            'Prefer not to answer'
            ],
            highestGradeOptions: [
            'No Education',
            '1st grade',
            '2nd grade',
            '3rd grade',
            '4th grade',
            '5th grade',
            '6th grade',
            '7th grade',
            '8th grade',
            '9th grade',
            '10th grade',
            '11th grade',
            'High school Diploma',
            'General Equivalency Diploma (GED)',
            'Vocational Certificate w/out Diploma/GED',
            'Vocational Certificate w/ Diploma/GED',
            'Some College - No Degree',
            'Associate\'s Degree',
            'Bachelor\'s Degree',
            'Graduate Degree',
            'Prefer not to answer'
            ],
            industryOptions: [
            'Business',
            'Computer',
            'Telecommunication',
            'Financial services',
            'Manufacturing',
            'Wholesale/retail/distribution',
            'Transportation',
            'Travel/hospitality',
            'Government',
            'Military',
            'Aerospace',
            'Healthcare/medical',
            'Insurance/legal',
            'Education',
            'Utilities',
            'Architecture/construction/real estate',
            'Agriculture',
            'Religious',
            'Social services',
            'Sales',
            'Gambling industry',
            'None',
            'N/A'
            ],
            maritalStatusOptions: [
            'Married',
            'Never married',
            'Living as married',
            'Separated',
            'Divorced',
            'Widowed',
            'N/A'
            ],
            religiousPreferenceOptions: [
            'Catholic',
            'Protestant',
            'Other Christian',
            'Jewish',
            'Muslim',
            'Buddhist',
            'Atheist/Agnostic',
            'No preference',
            'Other',
            'N/A'
            ],
            ageOptions: [
            'Under 18',
            '18 - 24',
            '25 - 34',
            '35 - 44',
            '45 - 54',
            '55 - 64',
            '65+',
            'Prefer not to answer'
            ],
            sexualOrientationOptions: [
            'Bisexual',
            'Lesbian or Gay',
            'Pansexual',
            'Straight',
            'I use a different term',
            'Questioning/Unsure',
            'Prefer not to answer'
            ],
            genderIdentityOptions: [
            'Intersex',
            'Man',
            'Non-Binary',
            'Two-Spirit',
            'Woman',
            'I use a different term',
            'Questioning/Unsure',
            'Prefer not to answer'
            ],
            transgenderOptions: [
            'Yes',
            'No',
            'Questioning/Unsure',
            'Prefer not to answer'
            ],
            gamblingFrequencyOptions: [
            'None in the last 30 days',
            '1 - 3 times in the last 30 days',
            '1 - 2 times per week',
            '3 - 6 times per week',
            'Daily',
            'Prefer not to answer'
            ],
            gamblingLocationsOptions: [
            'None',
            'Casino',
            'Race track',
            'Grocery/Convenience Store',
            'Internet',
            'Off-Track Betting (OTB)',
            'Bookie',
            'Bar/Restaurant',
            'Work',
            'School',
            'Home',
            'Church',
            'Community Site',
            'Other',
            'Prefer not to answer'
            ],
            // Options arrays
            serviceStatusOptions: [
            'Previously Attended Treatment',
            'Currently Attending Treatment',
            'Never Attended Treatment',
            'Previously Utilized Recovery Services',
            // 'Text box to enter RCOC name',
            'Currently Utilizing Recovery Services',
            'Never Utilized Recovery Services',
            'Previously Utilized Financial/Credit Counseling Services',
            'Currently Utilizing Financial/Credit Counseling Services',
            'Never Utilized Financial/Credit Counseling Services'
            ],
            
            previouslyAttendedTreatmentOptions: [
            'PG Inpatient',
            'PG Outpatient',
            'PG Residential',
            'SUD Inpatient',
            'SUD Outpatient',
            'SUD Residential'
            ],
            
            currentlyAttendingTreatmentOptions: [
            'PG Inpatient',
            'PG Outpatient',
            'PG Residential',
            'SUD Inpatient',
            'SUD Outpatient',
            'SUD Residential'
            ],
            
            previouslyUtilizedRecoveryServicesOptions: [
            // 'Recovery Community and Outreach Center'
            'Recovery Community and Outreach Center',
            'Youth Clubhouse',
            'Peer Advocate',
            'Open Access Center',
            'Family Navigator',
            'Regional Addiction Resource Center'
            ],
            
            currentlyUtilizingRecoveryServicesOptions: [
            'Recovery Community and Outreach Center',
            'Youth Clubhouse',
            'Peer Advocate',
            'Open Access Center',
            'Family Navigator',
            'Regional Addiction Resource Center'
            ],
            
            previouslyUtilizedFinancialServicesOptions: [
            'GamFin',
            'Other'
            ],
            
            currentlyUtilizingFinancialServicesOptions: [
            'GamFin',
            'Other'
            ],
        }
    },
    components: {
        BButton, BRow, BCol, BFormGroup, BCard, BCardBody, BSpinner, BFormRadioGroup, BFormRadio,
        DatePicker, vSelect
    },
    directives: {
        Ripple,
    },
    watch: {
        selectedRangeDate(val) {
            this.functionDateRange(val)
        },
        startDate(val) {
            if(val) {
                this.isBusy = true
                this.functionDateRange(this.selectedRangeDate)
                this.rangeDinamic ? this.rangeDinamic = false : ''
                this.applyFilters()
            }
        },
        endDate(val) {
            if(val) {
                this.isBusy = true
                this.applyFilters()
            }
        },
        filterClientType() { this.applyFilters() },
        filterClientStatus() { this.applyFilters() },
        filterReferralSource() { this.applyFilters() },
        filterServiceStatus() { this.applyFilters() },
        filterPresentingProblems() { this.applyFilters() },
        filterLegalInvolvement() { this.applyFilters() },
        filterReleaseSigned() { this.applyFilters() },
        filterRace() { this.applyFilters() },
        filterEthnicity() { this.applyFilters() },
        filterAsianOrigin() { this.applyFilters() },
        filterPacificIslanderOrigin() { this.applyFilters() },
        filterHouseholdIncome() { this.applyFilters() },
        filterGamblingTypes() { this.applyFilters() },
        filterEmploymentStatus() { this.applyFilters() },
        filterEducationLevel() { this.applyFilters() },
        filterVeteran() { this.applyFilters() },
        filterIndustry() { this.applyFilters() },
        filterMaritalStatus() { this.applyFilters() },
        filterReligiousPreference() { this.applyFilters() },
        filterAge() { this.applyFilters() },
        filterSexualOrientation() { this.applyFilters() },
        filterGenderIdentity() { this.applyFilters() },
        filterTransgender() { this.applyFilters() },
        filterGamblingFrequency() { this.applyFilters() },
        filterGamblingLocations() { this.applyFilters() }
    },
    methods: {
        makeid(length) {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for(var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        getCounter(payload, type) {
            var filterResult = this.arrayResults.filter(ele => ele.text === payload && ele.type === type)
            if(filterResult.length) {
                return filterResult[0].count
            } else {
                return 0
            }
        },
        resetFilters() {
            this.startDate = null
            this.endDate = null
            this.filterClientType = ''
            this.filterClientStatus = ''
            this.filterReferralSource = ''
            this.filterServiceStatus = ''
            this.filterPresentingProblems = ''
            this.filterLegalInvolvement = ''
            this.filterReleaseSigned = ''
            this.filterRace = ''
            this.filterEthnicity = ''
            this.filterAsianOrigin = ''
            this.filterPacificIslanderOrigin = ''
            this.filterHouseholdIncome = ''
            this.filterGamblingTypes = ''
            this.filterEmploymentStatus = ''
            this.filterEducationLevel = ''
            this.filterVeteran = ''
            this.filterIndustry = ''
            this.filterMaritalStatus = ''
            this.filterReligiousPreference = ''
            this.filterAge = ''
            this.filterSexualOrientation = ''
            this.filterGenderIdentity = ''
            this.filterTransgender = ''
            this.filterGamblingFrequency = ''
            this.filterGamblingLocations = ''
        },
        functionDateRange(val) {
            if(val === 'month') {
                if(this.startDate) {
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                }
            } else if(val === 'quarter') {
                if(this.startDate) {
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                }
            } else if(val === 'year') {
                if(this.startDate) {
                    var formatDateNew = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var getYear = moment(formatDateNew).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = '01/01/'+getYear
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                } else {
                    var getYear = moment(Date.now()).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = moment('01/01/'+getYear).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                }
            } else if(val === 'x') {
                this.selectedRangeDate = ''
                this.startDate = null
                this.endDate = null
            }
        },
        prevRange() {
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).subtract(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
        nextRange() {
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).add(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
        applyFilters() {
            this.isBusy = true
            
            // Reset counters
            this.arrayResults.forEach(ele => {
                ele.count = 0
            })

            let filtered = [...this.filteredData]

            // Date filter
            if(this.startDate && this.endDate) {
                filtered = filtered.filter(item => {
                    if(!item.contactDate) return false
                    const itemDate = moment(item.contactDate, 'MM-DD-YYYY')
                    const start = moment(this.startDate, 'DD/MM/YYYY')
                    const end = moment(this.endDate, 'DD/MM/YYYY')
                    return itemDate.isBetween(start, end, null, '[]')
                })
            }

            // Apply all filters
            if(this.filterClientType) {
                filtered = filtered.filter(item => item.clientType === this.filterClientType)
            }
            if(this.filterClientStatus) {
                filtered = filtered.filter(item => item.pifClientStatus === this.filterClientStatus)
            }
            if(this.filterReferralSource) {
                filtered = filtered.filter(item => item.referralSource === this.filterReferralSource)
            }
            if(this.filterServiceStatus) {
                filtered = filtered.filter(item => item.serviceStatus && item.serviceStatus.includes(this.filterServiceStatus))
            }
            if(this.filterPresentingProblems) {
                filtered = filtered.filter(item => item.presentingProblems && item.presentingProblems.includes(this.filterPresentingProblems))
            }
            if(this.filterLegalInvolvement) {
                filtered = filtered.filter(item => item.legalInvolvement === this.filterLegalInvolvement)
            }
            if(this.filterReleaseSigned) {
                filtered = filtered.filter(item => item.releaseSigned === this.filterReleaseSigned)
            }
            if(this.filterRace) {
                filtered = filtered.filter(item => item.race === this.filterRace)
            }
            if(this.filterEthnicity) {
                filtered = filtered.filter(item => item.ethnicity === this.filterEthnicity)
            }
            if(this.filterAsianOrigin) {
                filtered = filtered.filter(item => item.asianOrigin === this.filterAsianOrigin)
            }
            if(this.filterPacificIslanderOrigin) {
                filtered = filtered.filter(item => item.pacificIslanderOrigin === this.filterPacificIslanderOrigin)
            }
            if(this.filterHouseholdIncome) {
                filtered = filtered.filter(item => item.householdIncome === this.filterHouseholdIncome)
            }
            if(this.filterGamblingTypes) {
                filtered = filtered.filter(item => item.gamblingTypes && item.gamblingTypes.includes(this.filterGamblingTypes))
            }
            if(this.filterEmploymentStatus) {
                filtered = filtered.filter(item => item.employmentStatus === this.filterEmploymentStatus)
            }
            if(this.filterEducationLevel) {
                filtered = filtered.filter(item => item.educationLevels === this.filterEducationLevel)
            }
            if(this.filterVeteran) {
                filtered = filtered.filter(item => item.veteran === this.filterVeteran)
            }
            if(this.filterIndustry) {
                filtered = filtered.filter(item => item.industryOfEmployment === this.filterIndustry)
            }
            if(this.filterMaritalStatus) {
                filtered = filtered.filter(item => item.maritalStatus === this.filterMaritalStatus)
            }
            if(this.filterReligiousPreference) {
                filtered = filtered.filter(item => item.religiousPreference === this.filterReligiousPreference)
            }
            if(this.filterAge) {
                filtered = filtered.filter(item => item.age === this.filterAge)
            }
            if(this.filterSexualOrientation) {
                filtered = filtered.filter(item => item.sexualOrientation === this.filterSexualOrientation)
            }
            if(this.filterGenderIdentity) {
                filtered = filtered.filter(item => item.genderIdentity === this.filterGenderIdentity)
            }
            if(this.filterTransgender) {
                filtered = filtered.filter(item => item.transgender === this.filterTransgender)
            }
            if(this.filterGamblingFrequency) {
                filtered = filtered.filter(item => item.frequencyofGambling === this.filterGamblingFrequency)
            }
            if(this.filterGamblingLocations) {
                filtered = filtered.filter(item => item.gamblinglocationspast12months && item.gamblinglocationspast12months.includes(this.filterGamblingLocations))
            }

            // Count results
            this.totalIntakeForms = filtered.length

            filtered.forEach(item => {
                this.countField(item.clientType, 'New or Returning Client')
                this.countField(item.pifClientStatus, 'Client Status')
                this.countField(item.referralSource, 'Referral Source')
                this.countArray(item.serviceStatus, 'Service Status')
                this.countArray(item.presentingProblems, 'Presenting Problems')
                this.countField(item.legalInvolvement, 'Legal Involvement')
                this.countField(item.releaseSigned, 'Client Release Signed')
                this.countField(item.race, 'Race')
                this.countField(item.ethnicity, 'Hispanic Origin')
                this.countField(item.asianOrigin, 'Asian Origin')
                this.countField(item.pacificIslanderOrigin, 'Pacific Islander Origin')
                this.countField(item.householdIncome, 'Household Income')
                this.countArray(item.gamblingTypes, 'Types of Gambling')
                this.countField(item.employmentStatus, 'Employment Status')
                this.countField(item.educationLevels, 'Education Level')
                this.countField(item.veteran, 'Veteran')
                this.countField(item.industryOfEmployment, 'Industry')
                this.countField(item.maritalStatus, 'Marital Status')
                this.countField(item.religiousPreference, 'Religious Preference')
                this.countField(item.age, 'Age')
                this.countField(item.sexualOrientation, 'Sexual Orientation')
                this.countField(item.genderIdentity, 'Gender Identity')
                this.countField(item.transgender, 'Transgender')
                this.countField(item.frequencyofGambling, 'Gambling Frequency')
                this.countArray(item.gamblinglocationspast12months, 'Gambling Locations')
            })

            // Prepare CSV export
            this.jsonData = filtered.map(item => ({
                clientID: item.clientID || '',
                contactDate: item.contactDate || '',
                clientType: item.clientType || '',
                clientStatus: item.pifClientStatus || '',
                referralSource: item.referralSource || '',
                serviceStatus: Array.isArray(item.serviceStatus) ? item.serviceStatus.join(', ') : '',
                presentingProblems: Array.isArray(item.presentingProblems) ? item.presentingProblems.join(', ') : '',
                legalInvolvement: item.legalInvolvement || '',
                releaseSigned: item.releaseSigned || '',
                notes: item.notes || '',
                race: item.race || '',
                ethnicity: item.ethnicity || '',
                asianOrigin: item.asianOrigin || '',
                pacificIslanderOrigin: item.pacificIslanderOrigin || '',
                householdIncome: item.householdIncome || '',
                gamblingTypes: Array.isArray(item.gamblingTypes) ? item.gamblingTypes.join(', ') : '',
                employmentStatus: item.employmentStatus || '',
                educationLevel: item.educationLevels || '',
                veteran: item.veteran || '',
                zipCode: item.zipCode || '',
                industry: item.industryOfEmployment || '',
                maritalStatus: item.maritalStatus || '',
                religiousPreference: item.religiousPreference || '',
                age: item.age || '',
                sexualOrientation: item.sexualOrientation || '',
                genderIdentity: item.genderIdentity || '',
                transgender: item.transgender || '',
                gamblingFrequency: item.frequencyofGambling || '',
                ageFirstGambled: item.ageFirstGambled || '',
                past30DaysAmount: item.past30DaysAmountOfMoney || '',
                past30DaysTime: item.past30DaysHowMuchTime || '',
                past30DaysDays: item.past30DaysHowManyDays || '',
                gamblingLocations: Array.isArray(item.gamblinglocationspast12months) ? item.gamblinglocationspast12months.join(', ') : ''
            }))

            this.readyToExport = true
            this.isBusy = false
        },
        countField(value, type) {
            if(!value) return
            // console.log(this.arrayResults,value,type)
            const filter = this.arrayResults.filter(ele => ele.text === value && ele.type === type)
            if(filter.length) {
                filter[0].count += 1
            }
        },
        countArray(values, type) {
            if(!values || !Array.isArray(values)) return
            values.forEach(value => {
                const filter = this.arrayResults.filter(ele=> ele.text === value && ele.type === type)
                if(filter.length) {
                    filter[0].count += 1
                }
            })
        },
    },
    created() {
        var user = auth.currentUser
        db.collection('usuarios').doc(user.uid).get()
        .then(doc => {
            this.isDataSpecialist = false
            if(doc.data().role === 'staff') {
                if(doc.data().permissions.includes('data specialist')) {
                    this.isDataSpecialist = true
                }
            } else if(doc.data().role === 'admin') {
                this.isDataSpecialist = true
            }
        })

        // Load taxonomies
        // this.loadTaxonomies()

        // Load data from API
        // setTimeout(() => {
            this.$http.get('https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/prod/peer-services-intake-reports')
            .then(res => {
                this.filteredData = res.data
                this.applyFilters()
            })
        // }, 2500)

        this.arrayResults = []

        // Build arrayResults - Precargar todas las opciones con count: 0
        this.clientTypeOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'New or Returning Client', count: 0})
        })
        this.clientStatusOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Client Status', count: 0})
        })
        this.referralSourceOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Referral Source', count: 0})
        })
        this.serviceStatusOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Service Status', count: 0})
        })
        this.presentingProblemsOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Presenting Problems', count: 0})
        })
        this.yesNoOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Legal Involvement', count: 0})
        })
        this.yesNoOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Client Release Signed', count: 0})
        })
        this.raceOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Race', count: 0})
        })
        this.hispanicOriginOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Hispanic Origin', count: 0})
        })
        this.asianOriginOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Asian Origin', count: 0})
        })
        this.pacificIslanderOriginOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Pacific Islander Origin', count: 0})
        })
        this.householdIncomeOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Household Income', count: 0})
        })
        this.gamblingTypesOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Types of Gambling', count: 0})
        })
        this.employmentStatusOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Employment Status', count: 0})
        })
        this.highestGradeOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Education Level', count: 0})
        })
        this.yesNoOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Veteran', count: 0})
        })
        this.industryOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Industry', count: 0})
        })
        this.maritalStatusOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Marital Status', count: 0})
        })
        this.religiousPreferenceOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Religious Preference', count: 0})
        })
        this.ageOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Age', count: 0})
        })
        this.sexualOrientationOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Sexual Orientation', count: 0})
        })
        this.genderIdentityOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Gender Identity', count: 0})
        })
        this.transgenderOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Transgender', count: 0})
        })
        this.gamblingFrequencyOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Gambling Frequency', count: 0})
        })
        this.gamblingLocationsOptions.forEach(opt => {
            this.arrayResults.push({text: opt, type: 'Gambling Locations', count: 0})
        })
    }
}
</script>

<style>
.mx-input {
    height: 37px !important;
}
.hidden_header {
    display: none;
}
.form-control {
    background: #fff !important;
    background-color: #fff !important;
}
.range-date {
    padding: 8px;
    margin-top: 27px;
}
.vs__dropdown-option {
  white-space: normal !important;
}
.vs__dropdown-toggle {
  max-height: 38px;
}
.vs__selected-options {
  overflow: auto;
}
.vs__selected-options {
    overflow-x: hidden;
    overflow-y: hidden;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>